import { render, staticRenderFns } from "./FlightSearchForm.vue?vue&type=template&id=58db5c36&scoped=true"
import script from "./FlightSearchForm.vue?vue&type=script&lang=js"
export * from "./FlightSearchForm.vue?vue&type=script&lang=js"
import style0 from "./FlightSearchForm.vue?vue&type=style&index=0&id=58db5c36&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "58db5c36",
  null
  
)

export default component.exports